import { Delete, Download, UploadFile } from "@mui/icons-material";
import { Alert, Box, Button, Checkbox, Divider, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Grid, IconButton, InputLabel, ListItemText, MenuItem, Radio, RadioGroup, Select, Slider, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography, Modal, Backdrop, Fade, Step, Stepper, StepLabel } from "@mui/material";
import { useEffect, useState } from "react";
import axios from 'axios';
import { useRef } from "react";
import { availabilityValues, expertsApplyFormProps, generalAvailabilityValues, languageMarksValues, languagesValues, levelOfExpertiseValues, proficienyValues, regionalExperienceValues, registryRelatedExperienceValues, requiredExpertsApplyFormProps, specialtyFieldsValues, whoRegionCountries, yearsOfExperienceRange } from "../../consts/form-helpers/form-consts";
import { expertApply, expertEdit, getExpertByEmailHash, getExpertEndorsment, getExpertResume, verifyCaptcha, getExpertEmail, getExpertPin, GetFile } from "../../services/apply-service";
import HCaptcha from '@hcaptcha/react-hcaptcha';
import './become-expert-apply.css';
import { AppRoutes } from '../../consts/routes/app-routes';
import { customHasher } from "../../consts/helpers/customHasher";
import IntroStep from "./become-experts-form-steps/intro-step";
import PersonalInfoStep from "./become-experts-form-steps/personal-info-step";
import ProffesionalInfoStep from "./become-experts-form-steps/professional-info-step";
import MotivationStep from "./become-experts-form-steps/motivation-step";
import GlobalExpertiseStep from "./become-experts-form-steps/global-expertise-step";
import AvailabilityStep from "./become-experts-form-steps/availability-step";
import SubmissionStep from "./become-experts-form-steps/submission-step";

const BecomeExpertApplyComponent = () => {
    const HCAPTCHA_KEY = 'fb4046c2-1f94-4212-af88-f88274f21c4e';
    const fileInputRef = useRef(null);
    const [selectedFields, setSelectedFields] = useState([]);
    const [acceptConsent, setAcceptConsent] = useState('');
    const [declarationOfHonour, setDeclarationOfHonour] = useState('');
    const [countryOptions, setCountryOptions] = useState([]);
    const [countryOptionsRegions, setCountryOptionsRegions] = useState([]);
    const [countries, setCountries] = useState([]);
    const [fileResume, setFileResume] = useState(null);
    const [fileEndorsment, setFileEndorsment] = useState(null);
    const [error, setError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [emptyFormProps, setEmptyFormProps] = useState([]);
    const [consentError, setConsentError] = useState('');
    const [declarationOfHonourError, setDeclarationOfHonourError] = useState('');
    const [formData, setFormData] = useState({ ...expertsApplyFormProps });
    const [isSuccess, setIsSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [captchaToken, setCaptchaToken] = useState('');
    const [isOtherSelected, setIsOtherSelected] = useState(false);
    const [isSurgeryChecked, setIsSurgeryChecked] = useState(false);
    const [isGeneralAvailabilityOtherChecked, setIsGeneralAvailabilityOtherChecked] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [emailHash, setEmailHash] = useState(false);
    const [availability, setAvailability] = useState(availabilityValues);
    const [proficiency, setProficiency] = useState({ ...proficienyValues });
    const [blobUrl, setBlobUrl] = useState('');
    const [fieldsToUpdate, setFieldsToUpdate] = useState({});
    const [isSpecialtyEdited, setIsSpecialtyEdited] = useState(false);
    const [isRegionalExperienceEdited, setIsRegionalExperienceEdited] = useState(false);
    const [isRegistryRelatedExperienceEdited, setIsRegistryRelatedExperienceEdited] = useState(false);
    const [isLanguageProficiencyEdited, setIsLanguageProficiencyEdited] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [enteredEmail, setEnteredEmail] = useState("");
    const [enteredPin, setEnteredPin] = useState("");
    const [validationError, setValidationError] = useState("");
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [newResumeUploaded, setNewResumeUploaded] = useState(false);
    const [newEndorsmentUploaded, setNewEndorsmentUploaded] = useState(false);
    const [resumeError, setResumeError] = useState('');
    const [endorsementError, setEndorsementError] = useState('');
    const [beginRegistration, setBeginRegistration] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);

    const languageMarks = [...languageMarksValues];
    const languages = [...languagesValues];
    const [selectedLanguages, setSelectedLanguages] = useState([]);
    const level = [...levelOfExpertiseValues];
    const regionalExperience = [...regionalExperienceValues];
    const specificRegistryRelatedExperience = [...registryRelatedExperienceValues]
    const specialtyFields = [...specialtyFieldsValues];

    const steps = ['Personal information', 'Professional information', 'Motivation and experience', 'Global experience & expertise', 'Availability', 'Submission'];

    const validateStep = (step) => {
        if (step === 0) {
            const missing = ['name', 'surname', 'phone', 'email', 'institution', 'job_title', 'country'].filter((field) => !formData[field]);
            setEmptyFormProps(missing);
            return missing.length === 0;
        }

        if (step === 1) {
            const missing = ['specialty_ids', 'work_experience_range'].filter((field) => (!formData[field] || formData[field].length === 0));
            setEmptyFormProps(missing);
            return missing.length === 0;
        }

        if (step === 2) {
            const missing = ['motivation', 'professional_resume_base64', 'professional_endorsment_base64'].filter((field) => !formData[field]);
            setEmptyFormProps(missing);
            return missing.length === 0;
        }

        if (step === 3) {
            const missing = ['regional_experience', 'language_proficiency'].filter((field) => !formData[field] || formData[field].length === 0);
            setEmptyFormProps(missing);
            return missing.length === 0;
        }

        if (step === 4) {
            const missing = ['general_availability'].filter((field) => !formData[field]);
            setEmptyFormProps(missing);
            return missing.length === 0;
        }

        // setEmptyFormProps(missing);
        // return missing.length === 0;
    };

    const nextStep = () => {
        if (!validateStep(currentStep)) return;
        setCurrentStep((prev) => Math.min(prev + 1, steps.length - 1));
    };

    const prevStep = () => setCurrentStep((prev) => Math.max(prev - 1, 0));

    useEffect(() => {
        if (isEdit) {
            setIsModalOpen(true);
        }
    }, [isEdit]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        if (window.location.search !== '') {
            setIsEdit(true);
            const hash = new URLSearchParams(window.location.search).get('h');
            setEmailHash(hash);

            getExpertByEmailHash(hash)
                .then(res => {
                    console.log("Fetched Expert Data:", res);
                    res.regional_experience_countries = res.regional_experience_countries === null ? [] : res.regional_experience_countries.split(',').map(x => x.trim())

                    for (let region of res.regional_experience) {
                        setCountryOptionsRegions(prev => [...prev, ...countries.filter(x => new Set(whoRegionCountries[region.value]).has(x.value))]);
                    }

                    setFormData(res);

                    if (res.language_proficiency_other && res.language_proficiency_other !== '') {
                        const parts = res.language_proficiency_other.split(" - ");
                        const language = parts[0];
                        const label = parts[1];

                        setProficiency(prev => ({
                            ...prev,
                            Other: languageMarksValues.find(x => x.label === label)?.value || 0
                        }));
                    }

                    // Convert language proficiency to { English: 2, Spanish: 3 }
                    const newProficiencyValues = {};
                    res.language_proficiency?.forEach((lang) => {
                        newProficiencyValues[lang.value] = languageMarksValues.find(x => x.label === lang.proficiency)?.value || 0;
                    });

                    setProficiency(newProficiencyValues); // Update proficiency state

                    // Ensure availability is handled correctly
                    setAvailability({
                        onlineOnly: false,
                        onsiteOnly: false,
                        onlineOnsite: false,
                        [res.general_availability ?? 'onlineOnly']: true
                    });
                })
                .catch(err => console.error("Error fetching expert data:", err));
        }
    }, []);

    useEffect(() => {
        setError(null);

        axios.get('https://restcountries.com/v3.1/all?fields=name,flags,region,subregion')
            .then((response) => {
                const newCountries = response.data.map(country => ({
                    label: country.name.common === 'North Macedonia' ? 'Macedonia' : country.name.common,
                    value: country.name.common === 'North Macedonia' ? 'Macedonia' : country.name.common,
                    flag: country.flags.png,
                    region: country.region,
                    subregion: country.subregion
                }));

                setCountryOptions(newCountries.sort((a, b) => a.value.localeCompare(b.value)));
                setCountries(newCountries.sort((a, b) => a.value.localeCompare(b.value)));
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        if (!isEdit || !formData) return;

        //  Set resume only if its data exists
        if (formData.professional_resume_base64 && formData.professional_resume_base64_extension) {
            console.log(formData);
            setFileResume(prev => ({
                ...prev, // Keep previous state if it already exists
                name: `${formData.name}-${customHasher(formData.email)}-${formData.surname}.${formData.professional_resume_base64_extension}`,
                s3Key: `${formData.professional_resume_base64}.${formData.professional_resume_base64_extension}`
            }));
        }

        //  Set endorsement only if its data exists
        if (formData.professional_endorsment_base64 && formData.professional_endorsment_base64_extension) {
            console.log(formData);
            setFileEndorsment(prev => ({
                ...prev,
                name: `${formData.name}-${customHasher(formData.email)}-${formData.surname}.${formData.professional_endorsment_base64_extension}`,
                s3Key: `${formData.professional_endorsment_base64}.${formData.professional_endorsment_base64_extension}`
            }));
        }
    }, [isEdit, formData?.professional_resume_base64, formData?.professional_resume_base64_extension, formData?.professional_endorsment_base64, formData?.professional_endorsment_base64_extension]);

    const handleSliderChange = (language) => (e, value) => {
        setIsLanguageProficiencyEdited(isEdit);
        if (language !== 'Other') {
            setProficiency({ ...proficiency, [language]: value });

            if (value !== 0) {
                const entry = {
                    id: languages.find(l => l.value === language).id,
                    value: language,
                    proficiency: languageMarks.find(x => x.value === value).label
                };

                setFormData({
                    ...formData,
                    language_proficiency: [...(formData.language_proficiency?.filter(item => item.value !== language) || []), entry]
                });

                if (emptyFormProps.includes('language_proficiency')) {
                    setEmptyFormProps((props) => props.filter(prop => prop !== 'language_proficiency'));
                }
            } else {
                if (formData.language_proficiency.some(x => x.value === language)) {
                    const updatedLanguageProficiency = formData.language_proficiency.filter(x => x.value !== language);
                    setFormData({ ...formData, language_proficiency: [...updatedLanguageProficiency] });
                }
            }
        } else {
            setProficiency({ ...proficiency, [language]: value });
        }
    };

    const handleCaptchaVerify = token => {
        setError(null);
        setCaptchaToken(token);
    };

    const handleInputChange = e => {
        setIsOtherSelected(e.target.value === 'Other');

        setError(null);
        setFormData({ ...formData, [e.target.name]: e.target.value });

        if (isEdit) {
            setFieldsToUpdate({ ...fieldsToUpdate, [e.target.name]: e.target.value })
        }

        if (emptyFormProps.includes(e.target.name)) {
            setEmptyFormProps((props) => props.filter(prop => prop !== e.target.name));
        }
    };

    const handleAcceptConsent = e => {
        setAcceptConsent(e.target.value);
        setFormData({ ...formData, consent: e.target.value });
        setFieldsToUpdate({ ...fieldsToUpdate, consent: e.target.value })
        if (e.target.value !== 'no') {
            setConsentError('');
        };

        if (emptyFormProps.includes('consent')) {
            setEmptyFormProps((props) => props.filter(prop => prop !== 'consent'));
        }
    };

    const handleSpecialtySelectChange = (e) => {
        setFormData(prev => ({ ...prev, specialty_ids: e.target.value }));
        setIsSurgeryChecked(e.target.value.includes(specialtyFields.find(f => f.value.includes('Surgery'))?.id));

        if (isEdit) {
            setFieldsToUpdate(prev => ({ ...prev, specialty_ids: e.target.value }));
            setIsSurgeryChecked(e.target.value.includes(specialtyFields.find(f => f.value.includes('Surgery'))?.id));
        }

        if (emptyFormProps.includes('specialty_ids')) {
            setEmptyFormProps(props => props.filter(prop => prop !== 'specialty_ids'));
        }
    };

    const handleLanguagesSelectChange = e => { console.log(e); isEdit ? setSelectedLanguages(e) : setSelectedLanguages(e) };

    // const handleRegistryRelatedExperienceChange = (e) => {
    //     setFormData(prev => ({ ...prev, registry_related_experience: e.target.value }));
    //     console.log(formData);
    //     if (emptyFormProps.includes('registry_related_experience')) setEmptyFormProps(props => props.filter(prop => prop !== 'work_experience_range'));
    // };

    const handleRegionalExperienceCountryChange = e => {
        setFormData(prev => ({ ...prev, regional_experience_countries: e.target.value }));
        if (isEdit) {
            setFieldsToUpdate({ ...fieldsToUpdate, regional_experience_countries: e.target.value })
        }
    }

    const handleGeneralAvailabilityChange = (e) => {
        setFormData(prev => ({ ...prev, general_availability: e.target.value }));
        if (isEdit) {
            setFieldsToUpdate({ ...fieldsToUpdate, general_availability: e.target.value })
        }
        setIsGeneralAvailabilityOtherChecked(e.target.value === 3);
        if (emptyFormProps.includes('general_availability')) setEmptyFormProps(props => props.filter(prop => prop !== 'general_availability'));
    };

    const handleYearsOfExpRangeChange = (e) => {
        setFormData(prev => ({ ...prev, work_experience_range: e.target.value }));
        if (isEdit) {
            setFieldsToUpdate({ ...fieldsToUpdate, work_experience_range: e.target.value })
        }
        if (emptyFormProps.includes('work_experience_range')) setEmptyFormProps(props => props.filter(prop => prop !== 'work_experience_range'));
    };

    const validateForm = () => {
        let isFormValid = true;
        const props = !isEdit ? requiredExpertsApplyFormProps.filter(x => !x.includes(['professional_resume_base64', 'professional_endorsment_base64'])) : requiredExpertsApplyFormProps;

        for (let prop of props) {
            if (Array.isArray(formData[prop])) {
                if (formData[prop].length === 0) {
                    setEmptyFormProps((prev) => [...prev, prop]);
                    setError('Please fill out all required fields');
                    isFormValid = false;
                }
            }
            else {
                if (formData[prop] === '' || formData[prop] === null || formData[prop] === false) {
                    if (prop === 'consent') {
                        setConsentError('You must accept the terms to proceed.')
                        isFormValid = false;
                    };

                    setEmptyFormProps((prev) => [...prev, prop]);
                    setError('Please fill out all required fields');
                    isFormValid = false;
                };

                if (prop === 'consent' && acceptConsent === 'no') {
                    setConsentError('You must accept the terms to proceed.');
                    setError('Please fill out all required fields');
                    isFormValid = false;
                };
            }
        };

        return isFormValid;
    }

    const handleSubmit = async () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (validateForm()) {
            // verifyCaptcha({ token: captchaToken }).then((res) => {
            //     if (res.success) {
            if (isEdit) {
                const editedData = { id: formData.id, fieldsToUpdate };

                if (isSpecialtyEdited) {
                    editedData.specialty_ids = formData.specialty_ids;
                };

                if (isRegionalExperienceEdited) {
                    editedData.regional_experience = formData.regional_experience;
                };

                if (isRegistryRelatedExperienceEdited) {
                    editedData.registry_related_experience = formData.registry_related_experience;
                };

                if (isLanguageProficiencyEdited) {
                    editedData.language_proficiency = formData.language_proficiency;
                }

                if (editedData.fieldsToUpdate.hasOwnProperty('general_availability')) {
                    editedData.fieldsToUpdate.general_availability = editedData.fieldsToUpdate.general_availability === 1 ?
                        'Online support only' : editedData.fieldsToUpdate.general_availability === 2 ?
                            'Online and onsite support' : 'Other';
                }

                expertEdit(editedData).then(res => {
                    setSuccessMessage('Your form was successfully updated.');
                    setIsSuccess(res.status === 200);
                }).catch(err => console.log(err));
            } else {
                formData.general_availability = formData.general_availability === 1 ? 'Online support only' : formData.general_availability === 2 ? 'Online and onsite support' : 'Other';
                expertApply(formData).then(res => {
                    if (res?.response?.status) {
                        setError('Email already exists');
                    }
                    console.log(res);
                    setIsSuccess(res?.status === 201);
                    setSuccessMessage('Thank you for your expressed interest. Our team will contact you with more information on possible collaboration.');
                    //todo handle 500 error
                }).catch(err => { console.log(err); if (err.status === 406) { setError('Email already exists') } });
            };
        } else setError('Something went wrong. Please try again.');
        // } else {
        //     setError('Captcha verification failed. Please try again.');
        // }
        //     })
        // }
    }

    const handleFileChange = (e, isResume) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.type !== 'application/pdf') {
            const errorMsg = 'Only PDF files are allowed.';

            if (isResume) {
                setResumeError(errorMsg);
            } else {
                setEndorsementError(errorMsg);
            }

            e.target.value = '';
            return;
        }

        // Clear previous error
        if (isResume) {
            setResumeError('');
        } else {
            setEndorsementError('');
        }

        const fileExtension = file.name.split('.').pop();
        const reader = new FileReader();

        reader.onloadend = () => {
            const base64String = reader.result.split(',')[1];

            if (isResume) {
                //  Update only resume
                setFileResume({
                    name: file.name,
                    file: file  // Store actual file
                });

                setFormData(prevData => ({
                    ...prevData,
                    professional_resume_base64: base64String,
                    professional_resume_base64_extension: fileExtension
                }));

                if (isEdit) {
                    setFieldsToUpdate(prev => ({
                        ...prev,
                        professional_resume_base64: base64String,
                        professional_resume_base64_extension: fileExtension
                    }));

                    setNewResumeUploaded(true);
                }
            } else {
                //  Update only endorsement
                setFileEndorsment({
                    name: file.name,
                    file: file  // Store actual file
                });

                setFormData(prevData => ({
                    ...prevData, professional_endorsment_base64: base64String, professional_endorsment_base64_extension: fileExtension
                }));

                if (isEdit) {
                    setFieldsToUpdate(prev => ({
                        ...prev, professional_endorsment_base64: base64String, professional_endorsment_base64_extension: fileExtension
                    }));

                    setNewEndorsmentUploaded(true);
                }
            }
        };

        reader.readAsDataURL(file);

        // if (emptyFormProps.includes('professional_resume_base64')) setEmptyFormProps(props => props.filter(prop => prop !== 'professional_resume_base64'));
    };

    const handleFileRemove = (isResume) => {
        if (isResume) {
            setFileResume(null);
            setFormData({ ...formData, professional_resume_base64: null })
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        } else {
            setFileEndorsment(null);
            setFormData({ ...formData, professional_endorsment_base64: null })
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    };

    const handleRegionalExperienceChange = (field, years_of_experience) => {
        setIsRegionalExperienceEdited(isEdit);
        setCountryOptionsRegions(prev => [...prev, ...countries.filter(x => new Set(whoRegionCountries[field.value]).has(x.value))]);
        setFormData(prevState => {
            const existingEntry = prevState.regional_experience.find(x => x.value === field.value);

            if (existingEntry && existingEntry.years_of_experience === years_of_experience) {
                return { ...prevState, regional_experience: prevState.regional_experience.filter(x => x.value !== field.value) };
            }

            if (existingEntry) {
                return {
                    ...prevState, regional_experience: prevState.regional_experience.map(x =>
                        x.value === field.value ? { ...x, years_of_experience } : x
                    ),
                };
            }

            return {
                ...prevState, regional_experience: [...prevState.regional_experience,
                { id: field.id, value: field.value, years_of_experience }
                ]
            };
        });

        if (emptyFormProps.includes('regional_experience')) {
            setEmptyFormProps((props) => props.filter(prop => prop !== 'regional_experience'));
        }
    };

    const handleEmailBlur = () => { setEmailError(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) ? 'Invalid email format' : '') };

    const handleFileView = async (fileData, isResume) => {
        console.log(fileData);
        if (!fileData || (!fileData.s3Key && !fileData.name)) {
            return;
        }

        try {
            if (newResumeUploaded && isResume) {
                const blob = base64ToBlob(formData.professional_resume_base64, getFileContentType(formData.professional_resume_base64_extension));
                const blobUrl = URL.createObjectURL(blob);

                if (formData.professional_resume_base64_extension === 'pdf') {
                    window.open(blobUrl, "_blank");
                } else {
                    const link = document.createElement("a");
                    link.href = blobUrl;
                    link.download = fileData.name;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }

                return;
            };

            if (newEndorsmentUploaded && !isResume) {
                const blob = base64ToBlob(formData.professional_endorsment_base64, getFileContentType(formData.professional_endorsment_base64_extension));
                const blobUrl = URL.createObjectURL(blob);

                if (formData.professional_endorsment_base64_extension === 'pdf') {
                    window.open(blobUrl, "_blank");
                } else {
                    const link = document.createElement("a");
                    link.href = blobUrl;
                    link.download = fileData.name;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }

                return;
            };

            const fileName = fileData.s3Key || fileData.name; // Use S3 key if available, fallback to name
            const response = await GetFile(fileName);

            if (!response || !response.data) {
                throw new Error("File retrieval failed.");
            }

            const blob = response.data;
            let contentType = response.headers?.['content-type'] || '';

            // Fix incorrect content type if necessary
            if (contentType === "file/pdf") {
                contentType = "application/pdf";
            }

            const fixedBlob = new Blob([blob], { type: contentType });
            const fileUrl = URL.createObjectURL(fixedBlob);

            if (contentType.includes("pdf")) {
                window.open(fileUrl, '_blank');
            } else {
                const link = document.createElement("a");
                link.href = fileUrl;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error("Error opening file:", error);
        }
    };

    const base64ToBlob = (base64, contentType = "application/octet-stream") => {
        console.log(base64)
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    };

    const getFileContentType = (fileExtension) => {
        switch (fileExtension) {
            case 'pdf': return 'application/pdf';
            case 'doc': return 'application/msword';
            case 'docx': return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            default: return '';
        }
    }

    const handleVerify = async () => {
        try {
            const responseEmail = await getExpertEmail(formData.id);
            const responsePin = await getExpertPin(formData.id);

            // Convert email to lowercase and trim spaces
            const storedEmail = responseEmail.email.trim().toLowerCase();
            const enteredEmailFormatted = enteredEmail.trim().toLowerCase();

            // Convert PIN to a string and trim spaces
            const storedPin = String(responsePin.expert_pin).trim();
            const enteredPinFormatted = enteredPin.trim();

            // Compare emails and PINs after proper formatting
            if (storedEmail === enteredEmailFormatted && storedPin === enteredPinFormatted) {
                setIsAuthenticated(true);
                setIsModalOpen(false); // Close the modal
            } else {
                setValidationError("Invalid email or PIN. Please try again.");
            }
        } catch (error) {
            setValidationError("Error verifying credentials. Please try again.");
        }
    };

    const handleBeginRegistration = () => setBeginRegistration(prev => !prev);

    const stepContent = [
        <PersonalInfoStep props={{ formData, handleInputChange, emptyFormProps, handleEmailBlur, emailError, countryOptions }} />,
        <ProffesionalInfoStep props={{ handleSpecialtySelectChange, specialtyFields, formData, handleInputChange, emptyFormProps, isSurgeryChecked, handleYearsOfExpRangeChange, yearsOfExperienceRange }} />,
        <MotivationStep props={{ formData, handleInputChange, emptyFormProps, handleFileChange, handleFileRemove, handleFileView, endorsementError, resumeError, fileEndorsment, fileResume, isEdit }} />,
        <GlobalExpertiseStep props={{ formData, resumeError, fileInputRef, handleRegionalExperienceCountryChange, countryOptionsRegions, selectedLanguages, languageMarks, handleLanguagesSelectChange, proficiency, emptyFormProps, isEdit, handleSliderChange, languages, handleInputChange, regionalExperience, handleRegionalExperienceChange }} />,
        <AvailabilityStep props={{ formData, isGeneralAvailabilityOtherChecked, generalAvailabilityValues, handleGeneralAvailabilityChange, selectedLanguages, languageMarks, handleLanguagesSelectChange, proficiency, emptyFormProps, isEdit, handleSliderChange, languages, handleInputChange, regionalExperience, handleRegionalExperienceChange, setFormData }} />,
        <SubmissionStep props={{ formData, consentError, handleAcceptConsent, acceptConsent }} />
    ];

    return (
        <>
            {!beginRegistration && <IntroStep props={{ isModalOpen, handleBeginRegistration }} />}
            {isSuccess && (
                <div className="success-msg-div-bea">
                    <Alert className="success-msg-alert" severity="success">
                        <strong><h3>{successMessage}</h3></strong>
                    </Alert>
                </div>
            )}
            {(beginRegistration && !isSuccess) && (
                <div className={`form-container ${isModalOpen ? "blurred" : ""}`}>
                    <Box component="form" noValidate autoComplete="off" className="content-bea-form">
                        <Stepper activeStep={currentStep} alternativeLabel>
                            {steps.map((label) => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        <Box sx={{ mt: 4 }}>{stepContent[currentStep]}</Box>
                        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between' }}>
                            <Button disabled={currentStep === 0} onClick={prevStep}>Back</Button>
                            {currentStep < steps.length - 1 ? (
                                <Button variant="contained" onClick={nextStep}>Next</Button>
                            ) : (<Button variant="contained" onClick={handleSubmit}>Submit</Button>)}
                        </Box>
                        <Grid item xs={12}>
                            {error && (
                                <Alert variant="filled" severity="error">
                                    Error: {error}
                                </Alert>
                            )}
                        </Grid>
                    </Box>
                </div>
            )}
            <Modal open={isModalOpen} closeAfterTransition BackdropComponent={Backdrop} BackdropProps={{ timeout: 500 }} >
                <Fade in={isModalOpen}>
                    <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", bgcolor: "background.paper", boxShadow: 24, p: 4, borderRadius: 2, width: "400px", display: "flex", flexDirection: "column", gap: 2 }}>
                        <Typography variant="h6" align="center">Authentication Required</Typography>
                        <TextField label="Email" fullWidth value={enteredEmail} onChange={(e) => setEnteredEmail(e.target.value)} />
                        <TextField label="PIN" type="number" fullWidth value={enteredPin} onChange={(e) => setEnteredPin(e.target.value)} />
                        {validationError && <Alert severity="error">{validationError}</Alert>}
                        <Button variant="contained" color="primary" onClick={handleVerify}> Send </Button>
                    </Box>
                </Fade>
            </Modal>
        </>
    )
}

export default BecomeExpertApplyComponent;